<inner-section *ngFor="let section of step.sections; index as i" [section]="section" [sequence]="i" #innerSection>
</inner-section>
<dynamic-form [fields]="step.fields" [form]="form" *ngIf="step.fields.length>0" (submit)="onSubmit($event)"></dynamic-form>
